import axios from "axios";

export const graphqlRequest = async ({
  url,
  query,
  variables = {},
  token,
  authType = "Basic",
}) => {
  try {
    const res = await axios.post(
      url,
      {
        query,
        variables,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${authType} ${token}`,
        },
      },
    );

    if (res.data?.errors?.length) {
      const errorMessage =
        res.data.errors[0]?.message || "GraphQL request failed";

      console.error("GraphQL errors:", res.data.errors);
      throw new Error(errorMessage);
    }

    return res.data?.data;
  } catch (error) {
    console.error("GraphQL request error:", error?.response?.data || error);

    throw new Error(
      error?.response?.data?.errors?.[0]?.message ||
        error?.response?.data?.message ||
        error.message ||
        "GraphQL request failed",
    );
  }
};